module.exports = __webpack_public_path__ + "img/outline-ci-green.3e5e8f0.svg";